export default "__VITE_ASSET__kFDCkS43__"